import axios from 'axios';

const token = localStorage.getItem('accessToken');

const apiInternational = axios.create({
    baseURL: process.env.VUE_APP_INTERNATIONAL_API,
    headers: { 'Authorization': `bearer ${token}`, 'X-Client-Identifier': "DnePay" }
});

export default apiInternational;